import { z } from 'zod';
import { bulkCreateTopicTypes } from 'wasp/client/operations';
import type { CsvEntityConfig } from '../types';

const validationSchema = z.object({
  key: z.string().min(1, 'Key is required'),
  label: z.string().min(1, 'Label is required'),
  description: z.string().optional().default(''),
  icon: z.string().optional().default(''),
  isActive: z.string().optional().default('true'),
});

export const topicTypeConfig: CsvEntityConfig = {
  entityName: 'Topic Types',
  entityNameSingular: 'Topic Type',
  columns: [
    { key: 'key', label: 'Key', required: true, description: 'Unique identifier (lowercase, no spaces)', exampleValue: 'pillar' },
    { key: 'label', label: 'Label', required: true, description: 'Display name', exampleValue: 'Pillar of Community' },
    { key: 'description', label: 'Description', required: false, description: 'Optional description', exampleValue: 'Core pillars of the Community faith' },
    { key: 'icon', label: 'Icon', required: false, description: 'Lucide icon name', exampleValue: 'BookOpen' },
    { key: 'isActive', label: 'Is Active', required: false, description: 'true/false (default: true)', exampleValue: 'true' },
  ],
  validationSchema,
  exampleRows: [
    { key: 'pillar', label: 'Pillar of Community', description: 'Core pillars of the Community faith', icon: 'BookOpen', isActive: 'true' },
    { key: 'general', label: 'General Topic', description: 'General community topics', icon: 'Tag', isActive: 'true' },
  ],
  bulkCreateAction: bulkCreateTopicTypes as any,
};



